import CarrierBaseController from '../common/carrier.base.controller'

class CarrierallController extends CarrierBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, CarrierService, $translate, $stateParams, $scope, $location) {


    super(Auth, $state, User, CarrierService, Modal, $translate, $stateParams, $location)

    this.id = 'carrier.all'
    this.loading = true
    this.carriers = []
    this.page = 1
    this.total = 0
    this.pageLimit = 10
    this.maxPages = 10
    this.hasACL = {}
    this._status = 'all'
    this.userStatus = [{
        label: 'All',
        value: 'all'
      }, {
        label: 'Active',
        value: 'active'
      },
      {
        label: 'Inactive',
        value: 'inactive'
      }
    ]
    this.searchText = ''
    this.$location = $location
    this.branch = User.getUser().branchId;
    this.model.filterByAllBranch = false;
    this.filterByValue = null;
  }

  $onInit() {
    this.moment = moment
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData()
  }

  edit(carrier) {
    this.$state.go('carrier.edit', ({
      id: carrier.id
    }))
  }

  delete(carrier) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${carrier.id}</strong>?`,
      callback: (({
        modal,
        $scope
      }) => {
        this.Service.remove(carrier.id)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close()
            this.refresh()
          })
      }),
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  refresh() {
    this.loadData()
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/'+this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  loadData() {
    this.loading = true
    this.Service.all({
        queryText: '%' + this.searchText + '%',
        isQuery: false,
        branch : this.branch,
        filterByAllBranch: this.model.filterByAllBranch
      }, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total

        this.loading = false
        this.carriers = data.results
      })
      .catch((err) => {
        this.loading = false
        this.error = err.message
      })
  }

  toggleExpand(carrier) {
    carrier.expand = !carrier.expand;
  }

  search() {
    this.page = 1
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/'+this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.refresh()
  }

  filterByBranch(value) {
    this.page = 1;
    this.filterByValue = this.filterByValue === value ? undefined : value;
    this.model.filterByAllBranch = this.filterByValue ? true : false;
    this.loadData();
  }
}

export default CarrierallController;


// WEBPACK FOOTER //
// ./client/app/components/carrier/all/carrier.all.controller.js